var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:("odometer--container odometer--" + (_vm.animated ? 'active' : ''))},[_c('div',{staticClass:"odometer-custom"},[_c('i-odometer',{attrs:{"format":"( ddd),dd","value":_vm.num}}),_vm._v("\n    ₽\n  ")],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c05e9fee","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/TextOdometer.vue
// module id = 278
// module chunks = 0